export const nullifyChoice = (value) => (value === '' ? null : value);
export const toInt = (value) => value && parseInt(value, 10);
